import { useAppSelector } from "src/config/store";
import { Navigate } from "react-router-dom";
import LoginView from "./login-view";

export const Login = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return isAuthenticated ? <Navigate to={{ pathname: "/" }} /> : <LoginView />;
};
